import { SiteSetupProcessDataStep } from "../../types/api.types";

export const DEFAULT_STEP = SiteSetupProcessDataStep.name_and_pv_plants;
